import React, { ReactNode } from "react";
import { getArticle, getArticles } from "../../apis/api";
import { pageInfo, TitleInfo } from "../../models/system";
import { SubmenuTitle } from "../components/SubmenuTitle";

export class Home extends React.Component {
    state = { data: null as pageInfo<TitleInfo> | null, curpage: 0, pagecount: 0 };
    async componentDidMount() {
        let x = await getArticles(0, 10, 75);
        for (let i = 0; i < x.content?.length; i++) {
            let res = await getArticle(x.content[i].id)
            x.content[i].content = res.content;
        }

        this.setState({ data: x, pagecount: x.pageCount });

    }
    render(): ReactNode {
        return (
            <>
                <div className="home">
                    {
                        this.state.data?.content?.map(x => (
                            <div className="home_item">
                                <div className="home_item_title">
                                    <div className="itemTitle">{x.title}</div>

                                </div>
                                <div className="it" dangerouslySetInnerHTML={{ __html: x.content }} />
                            </div>
                        ))
                    }
                </div>
            </>
        )
    }
}